import useServiceAppState from './useServiceAppState';

/**
 * 테이블 설정 저장용 스크린 키를 생성합니다.
 * @description
 * - userId를 자동으로 prefix하여 유저별 테이블 설정을 보장합니다.
 * - 내부적으로 useServiceAppState(useSuspenseQuery)를 사용하므로, 반드시 Suspense 경계 아래에서 호출해야 합니다.
 * @param screenTableKey - 화면별 유니크 테이블 키
 * @example
 * // 기본 사용
 * const tableKey = useScreenTableKey('my-service-table');
 *
 * // 리소스 suffix가 필요한 경우
 * const tableKey = useScreenTableKey(`my-table:${resourceId}`);
 */
const useScreenTableKey = (screenTableKey: string) => {
  const { state } = useServiceAppState();
  return `${state.userId}:${screenTableKey}`;
};

export default useScreenTableKey;
